import React, { Component } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import * as AnnotationsModule from "highcharts/modules/annotations";
import { isMobileDevice, convertToCurrencyFormat } from "../../helpers/Utils";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import moment from "moment";

const IS_MOBILE = isMobileDevice();

AnnotationsModule(Highcharts);

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderGraph() {
    const { rawGraphData } = this.props;
    const data = rawGraphData.reduce(
      (obj, item) => ({ ...obj, [item.month]: item.total }),
      {}
    );
    const options = {
      chart: {
        type: "column",
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
      },
      xAxis: {
        title: { text: "Time Period", margin: 10 },
        categories: Object.keys(data).map((item) => {
          return moment(item).format('MMM YYYY');
        }),
      },
      yAxis: {
        title: {
          text: "Amount Collected",
          margin: 20,
        },
        labels: {
          formatter() {
            return convertToCurrencyFormat(this.value, "");
          },
        },
      },
      chart: {
        backgroundColor: "white",
        style: {
          width: "inherit",
          height: 400,
          fontSize: 16,
          fontFamily: "'Poppins', sans-serif",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          pointPadding: 0.4, 
          borderWidth: 0,
        },
      },

      tooltip: {
        formatter() {
          let date = this.x;
          Object.keys(data).map((item) => {
            if (item.startsWith(this.x)) {
              date = item;
            }
          });
          return `<div><b>${convertToCurrencyFormat(
            this.y
          )}</b><br/><b>${date}</b></div>`;
        },
      },

      series: [
        {
          data: Object.values(data),
          type: "column",
          color: StyleConstants.color.darkBlue,
        },
      ],
    };
    return (
      <div
        style={{
          margin: IS_MOBILE ? "0 10px 0 0" : "20px 30px 20px 20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          style={{ zIndex: 0 }}
        />
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: 0,
          width: "100%",
          backgroundColor: "white",
          marginTop: 5,
          marginBottom: 30,
          justifyContent: "center",
          height: "max-content",
          borderRadius: 10,
          boxShadow: "1px 2px 6px #8b9daf26",
        }}
      >
        {this.renderGraph()}
      </div>
    );
  }
}

export default BarChart;
